<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { z } from "zod";
import { verifyPhoneSignup } from '@auth-frontend-vue/lib/auth.actions';
import { useFormPlus } from '@/ui-plus/form/useFormPlus'
import { Loader2 } from 'lucide-vue-next'
import AutoFormFieldPin from "@/ui-plus/auto-form/AutoFormFieldPin.vue";

const props = defineProps<{
    phoneNumber: string
}>();

const emit = defineEmits<{
    onSuccess: [values: z.infer<typeof schema>],
    onCancel: [],
    onError: [error: any],
}>();

const schema = z.object({
    code: z.string().length(4, { message: '4 digits required' }),
})

const form = useForm({
    validationSchema: toTypedSchema(schema),
})

const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);

async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        const { error } = await verifyPhoneSignup({
            phoneNumber: props.phoneNumber,
            code: values.code,
        });
        if (error) {
            handleError(error, form);
        } else {
            emit('onSuccess', values);
        }
    })
}
</script>

<template>
    <AutoForm class="space-y-6"
              :schema="schema"
              :form="form"
              @submit="onSubmit"
              :field-config="{
                code: {
                    component: AutoFormFieldPin,
                    label: $t('oneTimePassword'),
                    description: $t('codeSentToPhone'),
                    inputProps: {
                        // @ts-ignore
                        length: 4,
                        autofocus: true,
                    },
                },
            }">
        <div class="text-sm font-medium text-destructive"
             v-if="globalError">
            {{ globalError }}
        </div>
        <div>
            <Button type="submit"
                    :disabled="isLoading"
                    class="w-full my-6">
                <Loader2 v-if="isLoading"
                         class="animate-spin" />
                Verify
            </Button>
        </div>
    </AutoForm>
    <Button variant="secondary"
            @click="emit('onCancel')"> Cancel </Button>
</template>
